/* ===== LA PLANQUE — chrome.js (thème Shopify)
   Curseur viseur, boutons magnétiques, transition wipe, easter egg,
   panier natif Shopify (AJAX Cart API) dans le drawer « Le sac discret ». ===== */
(function () {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const euros = (cents) => (cents / 100).toFixed(2).replace(".", ",") + " €";

  /* ---------- Panier Shopify ---------- */
  const veil = document.getElementById("cartVeil");
  const itemsEl = document.getElementById("cartItems");
  const totalEl = document.getElementById("cartTotal");
  const countEl = document.getElementById("cartCount");
  const promoOk = document.getElementById("promoOk");
  const promoInput = document.getElementById("promoInput");

  function renderCart(cart) {
    if (countEl) countEl.textContent = cart.item_count;
    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="cart-empty">Le sac est vide.<br>Rien à voir ici — justement.</p>'
        .replace("—", "·");
    } else {
      itemsEl.innerHTML = cart.items.map((it) => `
        <div class="cart-item" data-key="${it.key}">
          <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/, "_150x$1$2") : ""}" alt="" width="75">
          <div>
            <p class="cart-item-name">${it.product_title}</p>
            <p class="cart-item-price">${euros(it.price)}</p>
          </div>
          <div class="cart-qty">
            <button data-d="-1" aria-label="Retirer un exemplaire">−</button>
            <span>${it.quantity}</span>
            <button data-d="1" aria-label="Ajouter un exemplaire">+</button>
          </div>
        </div>`).join("");
    }
    if (totalEl) totalEl.textContent = euros(cart.total_price);
  }

  function refreshCart() {
    return fetch(window.LP.cartUrl + ".js")
      .then((r) => r.json())
      .then((cart) => { renderCart(cart); return cart; });
  }

  function addToCart(variantId, btn) {
    return fetch(window.LP.cartAddUrl + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    })
      .then((r) => {
        if (!r.ok) throw new Error("add failed");
        return refreshCart();
      })
      .then(() => {
        if (!btn) return;
        const seal = btn.querySelector(".seal");
        btn.classList.add("added");
        const label = btn.firstChild.textContent;
        btn.firstChild.textContent = "Planqué ";
        if (seal) seal.textContent = "✓";
        setTimeout(() => {
          btn.classList.remove("added");
          btn.firstChild.textContent = label;
          if (seal) seal.textContent = "→";
        }, 1400);
      })
      .catch(() => { if (btn) btn.firstChild.textContent = "Réessayer "; });
  }

  function openCart() { document.body.classList.add("cart-open"); refreshCart(); }
  function closeCart() { document.body.classList.remove("cart-open"); }

  document.addEventListener("click", (e) => {
    const add = e.target.closest("[data-variant-id]");
    if (add) { e.preventDefault(); addToCart(add.dataset.variantId, add); return; }
    if (e.target.closest("#cartBtn")) { openCart(); return; }
    if (e.target.closest("#cartClose") || e.target === veil) { closeCart(); return; }
    const q = e.target.closest(".cart-qty button[data-d]");
    if (q) {
      const item = q.closest(".cart-item");
      const qty = Number(item.querySelector("span").textContent) + Number(q.dataset.d);
      fetch(window.LP.cartChangeUrl + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.dataset.key, quantity: Math.max(0, qty) }),
      }).then(refreshCart);
    }
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeCart(); });

  const promoApply = document.getElementById("promoApply");
  if (promoApply) {
    promoApply.addEventListener("click", () => {
      const val = promoInput.value.trim().toUpperCase();
      if (!val) return;
      /* La remise réelle est appliquée par Shopify : /discount/CODE la scelle
         dans le panier, elle apparaît au checkout. */
      promoOk.hidden = false;
      promoOk.textContent = val + " scellé : visible au paiement.";
      fetch("/discount/" + encodeURIComponent(val)).finally(() => (promoInput.value = ""));
    });
  }

  const checkoutBtn = document.getElementById("checkoutBtn");
  if (checkoutBtn) checkoutBtn.addEventListener("click", () => (window.location.href = "/checkout"));

  refreshCart();

  /* ---------- Easter egg ---------- */
  const egg = document.getElementById("egg");
  if (egg) {
    const hint = document.getElementById("hintBtn");
    const close = document.getElementById("eggClose");
    if (hint) hint.addEventListener("click", () => (egg.hidden = false));
    if (close) close.addEventListener("click", () => (egg.hidden = true));
    const horloge = document.querySelector('[data-egg="horloge"]');
    if (horloge) {
      let clicks = 0;
      horloge.addEventListener("click", () => { if (++clicks >= 3) { egg.hidden = false; clicks = 0; } });
    }
  }

  /* ---------- Curseur viseur + magnétisme + wipe (gsap chargé en defer avant) ---------- */
  if (typeof gsap === "undefined") return;

  const cursor = document.getElementById("cursor");
  if (cursor && !reduceMotion) {
    const cx = gsap.quickTo(cursor, "x", { duration: 0.16, ease: "power2.out" });
    const cy = gsap.quickTo(cursor, "y", { duration: 0.16, ease: "power2.out" });
    window.addEventListener("mousemove", (e) => { cx(e.clientX); cy(e.clientY); });
    document.addEventListener("mouseover", (e) => {
      if (e.target.closest("a, button, .jeu-spot")) cursor.classList.add("on-link");
      else cursor.classList.remove("on-link");
    });
  }

  if (!reduceMotion && window.matchMedia("(hover: hover)").matches) {
    document.querySelectorAll(".btn-add, .btn-jeu").forEach((btn) => {
      const mx = gsap.quickTo(btn, "x", { duration: 0.35, ease: "power3.out" });
      const my = gsap.quickTo(btn, "y", { duration: 0.35, ease: "power3.out" });
      btn.addEventListener("mousemove", (e) => {
        const r = btn.getBoundingClientRect();
        mx((e.clientX - r.left - r.width / 2) * 0.25);
        my((e.clientY - r.top - r.height / 2) * 0.35);
      });
      btn.addEventListener("mouseleave", () => { mx(0); my(0); });
    });
  }

  const wipe = document.getElementById("wipe");
  if (wipe) {
    document.querySelectorAll('a[href^="/"]').forEach((a) => {
      if (a.getAttribute("href").includes("#")) return;
      a.addEventListener("click", (e) => {
        if (e.metaKey || e.ctrlKey || a.hasAttribute("data-variant-id")) return;
        e.preventDefault();
        wipe.classList.add("on");
        setTimeout(() => (window.location.href = a.href), reduceMotion ? 0 : 560);
      });
    });
  }
})();
